import { _callBackend } from '@/_api/api';
import type { APIRequest, APIResponsePromise } from '@/_types/api';
import type { Questionnaire } from '@/_types/models/questionnaire';
import type { User } from '@/_types/models/user';

export const getUser = async ({
  token,
  userId,
}: APIRequest<{ userId: number }>): APIResponsePromise<User> =>
  await _callBackend(`/users/${userId}`, 'GET', null, token);

export const getIsEmailTaken = async ({
  email,
  token,
}: APIRequest<{
  email: string;
}>): APIResponsePromise<{ is_available: boolean; user?: User }> =>
  await _callBackend(
    '/users/check_email_availability',
    'POST',
    { email },
    token,
  );

export const updateOverviewSetting = async ({
  lastActivityShouldIncludeAllActivity,
  token,
}: APIRequest<{
  lastActivityShouldIncludeAllActivity?: boolean;
}>): APIResponsePromise =>
  await _callBackend(
    '/users/update_overview_setting',
    'POST',
    {
      last_activity_should_include_all_activity:
        lastActivityShouldIncludeAllActivity,
    },
    token,
  );

export const getPreviewClientQuestionnaires = async ({
  companyId,
  token,
}: APIRequest<{
  companyId: number;
}>): APIResponsePromise<Array<Questionnaire>> =>
  await _callBackend(
    `/questionnaires/get_preview_client_questionnaires/?company_id=${companyId}`,
    'GET',
    null,
    token,
  );
